import type {ConnectElementConfig} from '../ConnectElementList';

export const NestingDemoConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "nestingDemo" */ '../../../components/NestingDemo/NestingDemo'
    ),
  releaseState: 'internal',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description:
    'Internal-only demo component to establish the pattern for nesting embedded components.',
  friendlyName: 'Nesting demo',
  htmlEvents: ['ondisputeslistclicked', 'ontransactionslistclicked'],
  customHtmlElementMethods: {
    setDisputesListOnClicked: {
      type: 'EventListenerMethod',
      event: 'ondisputeslistclicked',
      isInternal: false,
      description:
        'Sets the event listener that is called when the disputes tab is opened.',
    },
    setTransactionsListOnClicked: {
      type: 'EventListenerMethod',
      event: 'ontransactionslistclicked',
      isInternal: false,
      description:
        'Sets the event listener that is called when the transactions list tab is opened.',
    },
  },
};
